import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { colors } from "../../styles/variables";

export const CartIconSvg = () => {
  const theme = useContext(ThemeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__cart-icon"
      width="18"
      height="25"
      viewBox="0 0 21.556 25"
    >
      <path
        fill={theme.header?.shop?.navLinkColor || colors.white}
        id="prefix__Path_23"
        d="M116.328 141.365H102.38a.835.835 0 0 1-.818-.669l-2.969-14.737a.834.834 0 0 1 .818-1H119.3a.835.835 0 0 1 .818 1l-2.97 14.737a.833.833 0 0 1-.82.669zm-13.265-1.665h12.583l2.633-13.068H100.43z"
        data-name="Path 23"
        transform="translate(-98.576 -116.365)"
      />
      <path
        fill={theme.header?.shop?.navLinkColor || colors.white}
        id="prefix__Path_24"
        d="M115.694 120.449a.834.834 0 0 1-.765-.5c-.974-2.235-2.782-3.623-4.718-3.623s-3.743 1.388-4.718 3.623a.834.834 0 0 1-1.529-.667c1.244-2.852 3.637-4.624 6.247-4.624s5 1.772 6.247 4.624a.835.835 0 0 1-.764 1.168z"
        data-name="Path 24"
        transform="translate(-99.458 -114.657)"
      />
    </svg>
  );
};
